import React from 'react';
import { PageLayout } from '@/shared/layout';
import { useConstructionReworkOrders } from './hooks/useConstructionReworkOrders';
import { useCompany } from '@/modules/company/hooks/useCompany';
import { ReworkKPIBoard } from './components/ReworkKPIBoard';
import { ReworkToolbar } from './components/ReworkToolbar';
import { ReworkTable } from './components/ReworkTable';
import { Card } from '@/components/ui';

export default function ReworkListPage() {
  const { company } = useCompany();
  const { 
    reworkOrders, 
    stats, 
    isLoading, 
    filters, 
    setFilters 
  } = useConstructionReworkOrders(company?.id || '');

  return (
    <PageLayout
      title="Lệnh sửa lỗi & Khắc phục"
      description="Quản lý và theo dõi các công tác sửa chữa, khắc phục lỗi thi công"
      breadcrumbs={[{ label: 'Thi công' }, { label: 'Sửa lỗi' }]}
    >
      <ReworkKPIBoard stats={stats} isLoading={isLoading} />
      
      <ReworkToolbar 
        filters={filters} 
        onFilterChange={setFilters} 
        onAdd={() => {}} 
      />

      <Card className="overflow-hidden border-slate-100">
        <ReworkTable data={reworkOrders} isLoading={isLoading} />
      </Card>
    </PageLayout>
  );
}
